module.exports = __webpack_public_path__ + "static/banko-e0f6d37d4c81b96300e99b15d4368454.png";